import { Cookie } from '@atlassiansox/asc-core';

export type XsrfToken = string;

export type AtlassianIdAuth = {
  readonly xsrfToken: XsrfToken;
  readonly cloudSessionTokenCookie: Cookie;
};

export function isAtlassianIdAuth(value: unknown): value is AtlassianIdAuth {
  const auth = value as AtlassianIdAuth | undefined;
  return !!auth?.xsrfToken && !!auth.cloudSessionTokenCookie;
}
